class SyncInputWithTitle {
  constructor(inputId, titleSelector) {
    this.input = document.getElementById(inputId);
    this.title = document.querySelector(titleSelector);
    this.init();
  }

  init() {
    if (this.input && this.title) {
      this.input.value = this.title.innerHTML;
      this.input.disabled = true;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new SyncInputWithTitle('activity-name-input', 'h1');
});